import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  & > div {
    margin-right: 48px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
